import styled from 'styled-components';

export const EvidenceQuote = styled.blockquote`
  margin: 0;
  padding-left: var(--spacing-2);
  border-left: 2px solid var(--border-color);
  overflow-wrap: anywhere;
`;

export const EvidenceSource = styled.a`
  color: var(--gray-6);
  overflow-wrap: anywhere;
`;

export const MutedText = styled.span`
  color: var(--gray-6);
`;

export const ConflictNote = styled.p`
  margin: 0;
  color: var(--warning-text-color, var(--gray-7));
`;
